import * as ActionTypes from './ActionTypes'
import { Map } from 'immutable'

const getInitialState = () => {
  return Map({
    configuration: Map({}),
    globalConfiguration: Map({}),
  })
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case ActionTypes.VN_SET_CONFIGURATION:
      return state.set('configuration', Map(action.configuration))
    case ActionTypes.VN_SET_GLOBAL_CONFIGURATION:
      return state.set('globalConfiguration', Map(action.globalConfiguration))
    default:
      return state
  }
}

export default reducer
